import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getArchivedListNextPage } from '../../actions/archivedList';
import { getChatListNextPage } from '../../actions/chatList';
import { getSpamListNextPage } from '../../actions/spamList';
import { ChatList, ChatListLayout } from '../../components/ChatList';
import { EmptyChatList } from '../../components/EmptyChatList';
import { chatListSelector } from '../../selectors';
import { ERoute } from '../../types/route';
import { ChatListItemContainer } from '../ChatListItemContainer';
import { TopMenuContainer } from '../TopMenuContainer';

export const SubAgentChatListContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { chats, currentRoute, allChatsLoaded, movedToArchiveChatIds, movedToSpamChatIds, status } =
    useSelector(chatListSelector);

  const chatsToDisplay = React.useMemo(() => {
    /**
     * Если находимся на странице активных чатов,
     * заблокированные чаты (в спаме) или архивные чаты
     * или чаты которые только что перенесли в спам или архив - не выводим
     */
    if (currentRoute === ERoute.Messages) {
      return chats.filter(
        chat =>
          !chat.blocked &&
          !chat.archived &&
          !movedToSpamChatIds.includes(chat.chatId as string) &&
          !movedToArchiveChatIds.includes(chat.chatId as string),
      );
    }

    return chats;
  }, [currentRoute, chats, movedToSpamChatIds, movedToArchiveChatIds]);

  // TODO: запрос по id сотрудника будет подключен в задаче с ручками
  const getNextPage = React.useCallback(() => {
    if (currentRoute === ERoute.Spam) {
      return dispatch(getSpamListNextPage());
    }

    if (currentRoute === ERoute.Messages) {
      return dispatch(getChatListNextPage());
    }

    if (currentRoute === ERoute.Archive) {
      return dispatch(getArchivedListNextPage());
    }

    return;
  }, [dispatch, currentRoute]);

  return (
    <ChatListLayout
      topMenu={<TopMenuContainer isChangeListVisible={false} />}
      chatListContent={
        chatsToDisplay.length ? (
          <ChatList allChatsLoaded={allChatsLoaded} status={status} getNextPage={getNextPage}>
            {chatsToDisplay.map(chat => (
              <ChatListItemContainer chat={chat} key={`chat-item-${chat.chatId}`} />
            ))}
          </ChatList>
        ) : (
          <EmptyChatList route={currentRoute} withLinkButton={false} />
        )
      }
    />
  );
};
